// extracted by mini-css-extract-plugin
module.exports = {"textAlignRight":"Users_textAlignRight__1MaIn"};